<div class="spinner-wrapper my-4" *ngIf="loading" [class.float-loading]="hasData && !parentWrapped">
    <div class="row">
        <div class="col-12 text-center py-2">
            <i class="fas fa-spinner fa-4x fa-pulse mx-auto text-secondary mx-auto"></i>
        </div>
    </div>
</div>
